import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { WalletCustomerService } from '@customers/services/wallet.customer.service';
import { handleReadableMessage } from '@reusable/services/globals';
import { SharedService } from '@reusable/services/shared.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'store-user-wallet',
  standalone: false,
  templateUrl: './user-wallet.component.html',
  styleUrls: ['./user-wallet.component.scss']

})
export class UserWalletComponent implements OnInit {
  wallet: any;
  walletView$: any;
  constructor(private toastr: ToastrService, private wcs: WalletCustomerService, private title: Title, private data: SharedService) {}

  ngOnInit() {
    this.title.setTitle('سبيرو | رصيد سبيرو');
    this.walletView();
    this.data.changeMessage('wallet');
  }
  walletView() {
    if (this.walletView$) {
      this.walletView$.unsubscribe();
    }
    this.walletView$ = this.wcs.walletView().subscribe((response: any) => {
      switch (response.case) {
        case 1:
          this.wallet = response.wallet;
          if (response.wallet.walletTransactions?.length) {
            response.wallet.walletTransactions.map(wt => {
              wt.isRefunding = false;
            });
          }
          break;
      }
    });
  }

  refundRequest() {
    if (this.wallet.amount < 1) {
      // this.toastr.info('لا يوجد رصيد في محفظتك');
      return;
    }
    const body = {
      amount: this.wallet.refundableAmount
    };
    this.wcs.walletWithdrow(body).subscribe((response: any) => {
      handleReadableMessage(response);
      switch (response.case) {
        case 1:
          this.walletView();
          break;
      }
    });
  }
  refundWalletTransaction(wt) {
    if (wt) {
      wt.isRefunding = true;
      this.wcs.refundWalletTransaction(wt._id).subscribe((response: any) => {
        wt.isRefunding = false;
        switch (response.case) {

          case 1:
            this.walletView();
            break;
        }
      });
    }
  }
}